import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { SnackbarProvider } from "notistack";
import { I18nextProvider } from "react-i18next";
import SuspenseLoader from './pages/Landing/SuspenseLoader';
import i18n from './i18n';
import './i18n'


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <I18nextProvider i18n={i18n}>
        <Suspense fallback={<SuspenseLoader />}>
            <SnackbarProvider
                anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                autoHideDuration={4500}
                maxSnack={3}>
                <App />
            </SnackbarProvider>
        </Suspense>
    </I18nextProvider>
);
